// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"11":"87066cdafd61d519","1175":"a921d501e519bd73","1763":"525adbe84b8214da","2550":"dddff60e235b8772","3533":"ba8f0f6d01a5db2a","7273":"e1ca38b5e00b1213","9220":"02e25ebfc444b804"}[chunkId] + ".js";
};